export class ShowGroupingWrapper {
  tracked = new ShowGroupingTrackedWrapper(true);
  untracked = new ShowGroupingTrackedWrapper(false);
}

export class ShowGroupingTrackedWrapper {
  isShown = false;
  amount = 0;

  constructor(isShown: boolean) {
    this.isShown = isShown;
  }
}

export class ShowGroupingWrapperKpiBulkRequest {
  tracked = new ShowGroupingTrackedWrapperKpiBulkRequest(true);
  untracked = new ShowGroupingTrackedWrapperKpiBulkRequest(false);
}

export class ShowGroupingTrackedWrapperKpiBulkRequest {
  isShown = false;
  amount = 0;

  constructor(isShown: boolean) {
    this.isShown = isShown;
  }
}

export type GroupingKpiBulkRequest = keyof ShowGroupingWrapperKpiBulkRequest;
